import request from "@/utils/request"

export function listBanner(form) {
  return request.post("/common/listBanner", form)
}

/**
 * 获取新手产品
 * @param {*} form
 */
export function greenhand(form) {
  return request.post("/product/greenhand", form)
}

/**
 * 上首页! 的产品列表
 * @param {*} form
 */
export function firstPageList(form) {
  return request.post("/product/firstPageList", form)
}

/**
 * 获取热销产品
 * @param {*} form
 */
export function gethot(form) {
  return request.post("/product/gethot", form)
}

/**
 * 获取首页公告
 * @param {*} form
 */
export function getNotifyList(form) {
  return request.post("/notice/list", form)
}

/**
 * 获取首页公告
 * @param {*} form 
 */
export function getHomeNotify(form) {
  return request.post('/notice/all', form);
}

/**
 * 
 * @returns 是否显示反诈骗提示信息
 */
export function fetchLoginCount() {
  return request.post('/cust/getLogintTime');
}

/**
* 
* @returns 是否存在反诈骗提示信息
*/
export function bulletin() {
  return request.post('/bulletin/list');
}

export function getHotAuction(params) {
  return request.post("/product/getHotAuction", params)
}

export function getHomeContentList() {
  return request.post("/homeContent/getList")
}
